import { createContext, useContext, useEffect, useState } from "react";

// Same breakpoint as before (body width < 799px)
const MOBILE_MEDIA_QUERY = "(max-width: 798px)";

const MobileContext = createContext(window.matchMedia(MOBILE_MEDIA_QUERY).matches);

// Tracks the breakpoint live, so rotating a tablet or resizing the window switches layout
const MobileProvider = ({ children }) => {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(MOBILE_MEDIA_QUERY).matches);

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_MEDIA_QUERY);
    const handleChange = (e) => setIsMobile(e.matches);

    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  return <MobileContext.Provider value={isMobile}>{children}</MobileContext.Provider>;
};

const useMobile = () => {
  return useContext(MobileContext);
};

export { MobileProvider, useMobile };
